"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var geographicAddress_1 = __importDefault(require("./geographicAddress"));
var meterInfo_1 = __importDefault(require("./meterInfo"));
var deliveryPoint = /** @class */ (function () {
    function deliveryPoint(props) {
        this.deliveryPointId = props.deliveryPointId;
        this.geographicAddress = new geographicAddress_1.default(props.geographicAddress);
        this.reference = props.reference;
        this.regionCode = props.regionCode;
        this.commissioningDate = props.commissioningDate;
        this.removalDate = props.removalDate;
        this.deliveryPointStatusCode = props.deliveryPointStatusCode;
        this.meterLocationCode = props.meterLocationCode;
        this.meterLocationLabel = props.meterLocationLabel;
        this.productCode = props.productCode;
        this.meter = props.meter ? new meterInfo_1.default(props.meter) : null;
    }
    return deliveryPoint;
}());
exports.default = deliveryPoint;
